import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { NewdanhmucphieunhapAction } from 'src/actions/newdanhmucphieunhap.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getNewdanhmucphieunhapStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

import ExcelJS from 'exceljs';

import { saveAs } from 'file-saver';

import { Settings, Download, Upload, Cached } from '@material-ui/icons';

const NewdanhmucphieunhapLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedNewdanhmucphieunhapIds, setSelectedNewdanhmucphieunhapIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.newdanhmucphieunhap);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(NewdanhmucphieunhapAction.updateFilter(payload));
    dispatch(NewdanhmucphieunhapAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedNewdanhmucphieunhapIds;

    if (event.target.checked) {
      newSelectedNewdanhmucphieunhapIds = items.map((newdanhmucphieunhap) => newdanhmucphieunhap.id);
    } else {
      newSelectedNewdanhmucphieunhapIds = [];
    }

    setSelectedNewdanhmucphieunhapIds(newSelectedNewdanhmucphieunhapIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNewdanhmucphieunhapIds.indexOf(id);
    let newSelectedNewdanhmucphieunhapIds = [];

    if (selectedIndex === -1) {
      newSelectedNewdanhmucphieunhapIds = newSelectedNewdanhmucphieunhapIds.concat(selectedNewdanhmucphieunhapIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNewdanhmucphieunhapIds = newSelectedNewdanhmucphieunhapIds.concat(selectedNewdanhmucphieunhapIds.slice(1));
    } else if (selectedIndex === selectedNewdanhmucphieunhapIds.length - 1) {
      newSelectedNewdanhmucphieunhapIds = newSelectedNewdanhmucphieunhapIds.concat(selectedNewdanhmucphieunhapIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNewdanhmucphieunhapIds = newSelectedNewdanhmucphieunhapIds.concat(
        selectedNewdanhmucphieunhapIds.slice(0, selectedIndex),
        selectedNewdanhmucphieunhapIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNewdanhmucphieunhapIds(newSelectedNewdanhmucphieunhapIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, newdanhmucphieunhap) => {
    setSelected(newdanhmucphieunhap);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(NewdanhmucphieunhapAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(NewdanhmucphieunhapAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  const exportExcelOne = async(record) => {
    record = await dispatch(NewdanhmucphieunhapAction.findOne(record.id));

    if (record && record.data) {
      console.log(record.data);
      exportExcel(record.data);
    }
  }

  const exportExcel = async(record) => {
    try {
      // 1) tải template (đặt template.xlsx vào public/)
      const res = await fetch('/static/template_phieu_nhap_kho_1_1.xlsx');
      if (!res.ok) throw new Error(`Không tìm thấy template - trạng thái lỗi ${res.status}`);
      const arrayBuffer = await res.arrayBuffer();
  
      // 2) đọc workbook (chờ load xong)
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
  
      // debug: in ra tên sheet để chắc chắn workbook đã có sheet
      console.log('Worksheets loaded:', workbook.worksheets.map(ws => ws.name));
      if (!workbook.worksheets || workbook.worksheets.length === 0) {
        throw new Error('Template không chứa sheet nào (workbook.worksheets.length === 0)');
      }
  
      // 3) lấy sheet an toàn: ưu tiên sheet đầu tiên
      const sheet = workbook.getWorksheet(1) || workbook.worksheets[0] || workbook.getWorksheet('Sheet1');
      if (!sheet) throw new Error('Không tìm thấy sheet trong template (tên/idx không đúng)');
  
      // 4) ghi dữ liệu (ví dụ)
      // Ghi theo address (A1, B2...) hoặc row/col      
      if (record.no && record.no.toString().trim() !== '') {
        sheet.getCell('P5').value = record.no.toString().trim();
        sheet.getCell('P5').style = {
          ...sheet.getCell('P5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.co && record.co.toString().trim() !== '') {
        sheet.getCell('P6').value = record.co.toString().trim();
        sheet.getCell('P6').style = {
          ...sheet.getCell('P6').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.so && record.so.toString().trim() !== '') {
        sheet.getCell('J6').value = record.so.toString().trim();
        sheet.getCell('J6').style = {
          ...sheet.getCell('J6').style,
          font: { color: { argb: 'FFFF0000' }, name: 'Times New Roman', size: 9 }, // đỏ
        };
      }

      if (record.so_hoa_don_ban_hang && record.so_hoa_don_ban_hang.toString().trim() !== '') {
        sheet.getCell('J7').value = record.so_hoa_don_ban_hang.toString().trim();
        sheet.getCell('J7').style = {
          ...sheet.getCell('J7').style,
          font: { color: { argb: 'FFFF0000' }, name: 'Times New Roman', size: 9 }, // đỏ
        };
      }
      
      if (record.ngay && record.ngay.toString().trim() !== '') {
        sheet.getCell('H5').value = record.ngay.toString().trim();
        sheet.getCell('H5').style = {
          ...sheet.getCell('H5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, italic: true, },
        };
      }
      
      if (record.thang && record.thang.toString().trim() !== '') {
        sheet.getCell('J5').value = record.thang.toString().trim();
        sheet.getCell('J5').style = {
          ...sheet.getCell('J5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, italic: true, },
        };
      }
      
      if (record.nam && record.nam.toString().trim() !== '') {
        sheet.getCell('L5').value = record.nam.toString().trim();
        sheet.getCell('L5').style = {
          ...sheet.getCell('L5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, italic: true, },
        };
      }
      
      if (record.ho_va_ten_nguoi_giao && record.ho_va_ten_nguoi_giao.toString().trim() !== '') {
        sheet.getCell('C8').value = record.ho_va_ten_nguoi_giao.toString().trim();
        sheet.getCell('C8').style = {
          ...sheet.getCell('C8').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.theo && record.theo.toString().trim() !== '') {
        sheet.getCell('B9').value = record.theo.toString().trim();
        sheet.getCell('B9').style = {
          ...sheet.getCell('B9').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.theo_so && record.theo_so.toString().trim() !== '') {
        sheet.getCell('I9').value = record.theo_so.toString().trim();
        sheet.getCell('I9').style = {
          ...sheet.getCell('I9').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.theo_so_ngay && record.theo_so_ngay.toString().trim() !== '') {
        sheet.getCell('B10').value = record.theo_so_ngay.toString().trim();
        sheet.getCell('B10').style = {
          ...sheet.getCell('B10').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.theo_so_thang && record.theo_so_thang.toString().trim() !== '') {
        sheet.getCell('D10').value = record.theo_so_thang.toString().trim();
        sheet.getCell('D10').style = {
          ...sheet.getCell('D10').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.theo_so_nam && record.theo_so_nam.toString().trim() !== '') {
        sheet.getCell('G10').value = record.theo_so_nam.toString().trim();
        sheet.getCell('G10').style = {
          ...sheet.getCell('G10').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.theo_so_cua && record.theo_so_cua.toString().trim() !== '') {
        sheet.getCell('I10').value = record.theo_so_cua.toString().trim();
        sheet.getCell('I10').style = {
          ...sheet.getCell('I10').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.khohang_ma && record.khohang_ma.toString().trim() !== '' && record.khohang_ten.toString().trim() !== '') {
        sheet.getCell('C11').value = record.khohang_ma.toString().trim() + ' - ' + record.khohang_ten.toString().trim();
        sheet.getCell('C11').style = {
          ...sheet.getCell('C11').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.khohang_dia_chi && record.khohang_dia_chi.toString().trim() !== '') {
        sheet.getCell('I11').value = record.khohang_dia_chi.toString().trim();
        sheet.getCell('I11').style = {
          ...sheet.getCell('I11').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.newdanhmucphieunhapchitiets && record.newdanhmucphieunhapchitiets.length > 0) {
        let newdanhmucphieunhapchitiets = [...record.newdanhmucphieunhapchitiets].sort((a, b) => a.index - b.index);
        let startTableRow = 15;
        let lastTabelRow = newdanhmucphieunhapchitiets.length + startTableRow;
        let _tongSoLuongChungTu = 0;
        let _tongSoLuongThucNhap = 0;
        let _tongDonGia = 0;
        let _tongDonGiaSauChietKhau = 0;
        let _tongSoLuong = 0;
        let _tongThanhTien = 0;

        for (let i = 0; i < newdanhmucphieunhapchitiets.length; i++) {
          let chitiet = newdanhmucphieunhapchitiets[i];
          let so_luong_chung_tu = Number(chitiet.so_luong_chung_tu.trim());
          let so_luong_thuc_nhap = Number(chitiet.so_luong_thuc_nhap.trim());
          let don_gia = 0;
          let don_gia_sau_chiet_khau = 0;
          let so_luong = 0;
          let chiet_khau = 0;
          let keyChietKhau = undefined;

          if (chitiet.price_key == 'gia_thuc_nhap_si_1') keyChietKhau = 'chiet_khau_1';
          else if (chitiet.price_key == 'gia_thuc_nhap_si_2') keyChietKhau = 'chiet_khau_2';
          else if (chitiet.price_key == 'gia_thuc_nhap_si_3') keyChietKhau = 'chiet_khau_3';

          chiet_khau = numeral(keyChietKhau && chitiet?.[keyChietKhau] || 0).format('0,0[.]0') + '%';

          if (typeof chitiet['so_luong'] !== 'undefined' && chitiet['so_luong']) {
            so_luong = Number(chitiet['so_luong']);
          }

          if (typeof chitiet['sanpham_gia_nhap'] !== 'undefined' && chitiet['sanpham_gia_nhap']) {
            don_gia = Number(chitiet['sanpham_gia_nhap']);
          }

          if (chitiet.price_key && typeof chitiet['sanpham_' + chitiet.price_key] !== 'undefined' && chitiet['sanpham_' + chitiet.price_key]) {
            don_gia_sau_chiet_khau = Number(chitiet['sanpham_' + chitiet.price_key]);
          }

          let thanh_tien = don_gia_sau_chiet_khau * so_luong;

          _tongSoLuongChungTu += so_luong_chung_tu;
          _tongSoLuongThucNhap += so_luong_thuc_nhap;
          _tongDonGia += don_gia;
          _tongDonGiaSauChietKhau += don_gia_sau_chiet_khau;
          _tongSoLuong += so_luong;
          _tongThanhTien += thanh_tien;

          sheet.getRow(i + startTableRow).height = 60;
          sheet.mergeCells('B' + (i + startTableRow) + ':C' + (i + startTableRow));
          sheet.mergeCells('D' + (i + startTableRow) + ':E' + (i + startTableRow));
          sheet.mergeCells('K' + (i + startTableRow) + ':L' + (i + startTableRow));
          sheet.mergeCells('M' + (i + startTableRow) + ':N' + (i + startTableRow));

          sheet.getCell('A' + (i + startTableRow)).value = i + 1;
          sheet.getCell('A' + (i + startTableRow)).style = { 
            ...sheet.getCell('A' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
          
          sheet.getCell('B' + (i + startTableRow)).value = chitiet?.sanpham_ma?.trim();
          sheet.getCell('B' + (i + startTableRow)).style = { 
            ...sheet.getCell('B' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('D' + (i + startTableRow)).value = chitiet?.sanpham_ten?.trim();
          sheet.getCell('D' + (i + startTableRow)).style = { 
            ...sheet.getCell('D' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
          
          sheet.getCell('F' + (i + startTableRow)).value = numeral(so_luong).format('0,0[.]0');
          sheet.getCell('F' + (i + startTableRow)).style = { 
            ...sheet.getCell('F' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('G' + (i + startTableRow)).value = numeral(don_gia).format('0,0[.]0');
          sheet.getCell('G' + (i + startTableRow)).style = { 
            ...sheet.getCell('G' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('H' + (i + startTableRow)).value = chiet_khau;
          sheet.getCell('H' + (i + startTableRow)).style = { 
            ...sheet.getCell('H' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('I' + (i + startTableRow)).value = numeral(don_gia_sau_chiet_khau).format('0,0[.]0');
          sheet.getCell('I' + (i + startTableRow)).style = { 
            ...sheet.getCell('I' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('J' + (i + startTableRow)).value = numeral(thanh_tien).format('0,0[.]0');
          sheet.getCell('J' + (i + startTableRow)).style = { 
            ...sheet.getCell('J' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('K' + (i + startTableRow)).value = chitiet?.so_khung?.trim();
          sheet.getCell('K' + (i + startTableRow)).style = { 
            ...sheet.getCell('K' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('M' + (i + startTableRow)).value = chitiet?.so_may?.trim();
          sheet.getCell('M' + (i + startTableRow)).style = { 
            ...sheet.getCell('M' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('O' + (i + startTableRow)).value = chitiet?.dang_kiem?.trim();
          sheet.getCell('O' + (i + startTableRow)).style = { 
            ...sheet.getCell('O' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('P' + (i + startTableRow)).value = chitiet?.ghi_chu?.trim();
          sheet.getCell('P' + (i + startTableRow)).style = { 
            ...sheet.getCell('P' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
        }

        sheet.getRow(lastTabelRow).height = 15;
        sheet.mergeCells('A' + (lastTabelRow) + ':E' + (lastTabelRow));
        sheet.mergeCells('K' + (lastTabelRow) + ':L' + (lastTabelRow));
        sheet.mergeCells('M' + (lastTabelRow) + ':N' + (lastTabelRow));

        sheet.getCell('A' + (lastTabelRow)).value = "Cộng";
        sheet.getCell('A' + (lastTabelRow)).style = { 
          ...sheet.getCell('A' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('F' + (lastTabelRow)).value = _tongSoLuong == 0 ? 'x' : numeral(_tongSoLuong).format('0,0[.]0');
        sheet.getCell('F' + (lastTabelRow)).style = { 
          ...sheet.getCell('F' + (lastTabelRow)).style,
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, }, 
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('G' + (lastTabelRow)).value = _tongDonGia == 0 ? 'x' : numeral(_tongDonGia).format('0,0[.]0');
        sheet.getCell('G' + (lastTabelRow)).style = { 
          ...sheet.getCell('G' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('H' + (lastTabelRow)).value = 'x';
        sheet.getCell('H' + (lastTabelRow)).style = { 
          ...sheet.getCell('H' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('I' + (lastTabelRow)).value = _tongDonGiaSauChietKhau == 0 ? 'x' : numeral(_tongDonGiaSauChietKhau).format('0,0[.]0');
        sheet.getCell('I' + (lastTabelRow)).style = { 
          ...sheet.getCell('I' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };
        
        sheet.getCell('J' + (lastTabelRow)).value = _tongThanhTien == 0 ? 'x' : numeral(_tongThanhTien).format('0,0[.]0');
        sheet.getCell('J' + (lastTabelRow)).style = { 
          ...sheet.getCell('J' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('K' + (lastTabelRow)).value = 'x';
        sheet.getCell('K' + (lastTabelRow)).style = { 
          ...sheet.getCell('K' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('M' + (lastTabelRow)).value = 'x';
        sheet.getCell('M' + (lastTabelRow)).style = { 
          ...sheet.getCell('M' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('O' + (lastTabelRow)).value = 'x';
        sheet.getCell('O' + (lastTabelRow)).style = { 
          ...sheet.getCell('O' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('P' + (lastTabelRow)).value = 'x';
        sheet.getCell('P' + (lastTabelRow)).style = { 
          ...sheet.getCell('P' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getRow(lastTabelRow + 2).height = 15;
        sheet.getRow(lastTabelRow + 3).height = 15;

        sheet.mergeCells('A' + (lastTabelRow + 1) + ':P' + (lastTabelRow + 1));

        sheet.getCell('A' + (lastTabelRow + 2)).value = '- Tổng số tiền (viết bằng chữ):';
        sheet.getCell('A' + (lastTabelRow + 2)).style = { 
          ...sheet.getCell('A' + (lastTabelRow + 2)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet.getCell('D' + (lastTabelRow + 2)).value = record.tong_so_tien_viet_bang_chu + './.';
        sheet.getCell('D' + (lastTabelRow + 2)).style = { 
          ...sheet.getCell('D' + (lastTabelRow + 2)).style, 
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet.getCell('A' + (lastTabelRow + 3)).value = '- Số chứng từ gốc kèm theo:';
        sheet.getCell('A' + (lastTabelRow + 3)).style = { 
          ...sheet.getCell('A' + (lastTabelRow + 3)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet.getCell('D' + (lastTabelRow + 3)).value = record.so_chung_tu_goc_kem_theo;
        sheet.getCell('D' + (lastTabelRow + 3)).style = { 
          ...sheet.getCell('D' + (lastTabelRow + 3)).style, 
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        //từ cột 4 -> 16
        for (let c = 4; c <= 16; c++) {
          const cellfooter = sheet.getCell(lastTabelRow + 2, c);
          const cellfooter1 = sheet.getCell(lastTabelRow + 3, c);
          cellfooter.border = {
            bottom: { style: 'dotted', color: { argb: 'FF000000' } },
          };
          cellfooter1.border = {
            bottom: { style: 'dotted', color: { argb: 'FF000000' } },
          };
        }

        //==========

        sheet.getRow(lastTabelRow + 5).height = 15;
        sheet.getRow(lastTabelRow + 6).height = 15;
        sheet.getRow(lastTabelRow + 7).height = 15;
        sheet.getRow(lastTabelRow + 8).height = 15;

        sheet.mergeCells('A' + (lastTabelRow + 6) + ':D' + (lastTabelRow + 6));
        sheet.mergeCells('A' + (lastTabelRow + 7) + ':D' + (lastTabelRow + 7));

        sheet.mergeCells('E' + (lastTabelRow + 6) + ':H' + (lastTabelRow + 6));
        sheet.mergeCells('E' + (lastTabelRow + 7) + ':H' + (lastTabelRow + 7));

        sheet.mergeCells('I' + (lastTabelRow + 6) + ':K' + (lastTabelRow + 6));
        sheet.mergeCells('I' + (lastTabelRow + 7) + ':K' + (lastTabelRow + 7));

        sheet.mergeCells('L' + (lastTabelRow + 5) + ':P' + (lastTabelRow + 5));
        sheet.mergeCells('L' + (lastTabelRow + 6) + ':P' + (lastTabelRow + 6));
        sheet.mergeCells('L' + (lastTabelRow + 7) + ':P' + (lastTabelRow + 7));
        sheet.mergeCells('L' + (lastTabelRow + 8) + ':P' + (lastTabelRow + 8));

        sheet.getCell('A' + (lastTabelRow + 6)).value = 'Người lập phiếu';
        sheet.getCell('A' + (lastTabelRow + 6)).style = { 
          ...sheet.getCell('A' + (lastTabelRow + 6)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('A' + (lastTabelRow + 7)).value = '(Ký, họ tên)';
        sheet.getCell('A' + (lastTabelRow + 7)).style = { 
          ...sheet.getCell('A' + (lastTabelRow + 7)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, italic: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('E' + (lastTabelRow + 6)).value = 'Người giao hàng';
        sheet.getCell('E' + (lastTabelRow + 6)).style = { 
          ...sheet.getCell('E' + (lastTabelRow + 6)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('E' + (lastTabelRow + 7)).value = '(Ký, họ tên)';
        sheet.getCell('E' + (lastTabelRow + 7)).style = { 
          ...sheet.getCell('E' + (lastTabelRow + 7)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, italic: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('I' + (lastTabelRow + 6)).value = 'Thủ kho';
        sheet.getCell('I' + (lastTabelRow + 6)).style = { 
          ...sheet.getCell('I' + (lastTabelRow + 6)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('I' + (lastTabelRow + 7)).value = '(Ký, họ tên)';
        sheet.getCell('I' + (lastTabelRow + 7)).style = { 
          ...sheet.getCell('I' + (lastTabelRow + 7)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, italic: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('L' + (lastTabelRow + 5)).value = 'Ngày ...... tháng ...... năm ......';
        sheet.getCell('L' + (lastTabelRow + 5)).style = { 
          ...sheet.getCell('L' + (lastTabelRow + 5)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, italic: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('L' + (lastTabelRow + 6)).value = 'Kế toán trưởng';
        sheet.getCell('L' + (lastTabelRow + 6)).style = { 
          ...sheet.getCell('L' + (lastTabelRow + 6)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('L' + (lastTabelRow + 7)).value = '(Hoặc bộ phận có nhu cầu nhập)';
        sheet.getCell('L' + (lastTabelRow + 7)).style = { 
          ...sheet.getCell('L' + (lastTabelRow + 7)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9 },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('L' + (lastTabelRow + 8)).value = '(Ký, họ tên)';
        sheet.getCell('L' + (lastTabelRow + 8)).style = { 
          ...sheet.getCell('L' + (lastTabelRow + 8)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, italic: true },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'center', 
          },
        };

        //==========

        const startRow = startTableRow;
        const endRow = lastTabelRow; // vd = 19
        const startCol = 1; // A
        const endCol = 16; // P

        // 1) tạo/đặt border cho đúng vùng B14:I(endRow)
        for (let r = startRow; r <= endRow; r++) {
          for (let c = startCol; c <= endCol; c++) {
            const cell = sheet.getCell(r, c);
            // set border (tạo ô trong vùng này thôi)
            cell.border = {
              top:    { style: 'thin', color: { argb: 'FF000000' } },
              left:   { style: 'thin', color: { argb: 'FF000000' } },
              bottom: { style: 'thin', color: { argb: 'FF000000' } },
              right:  { style: 'thin', color: { argb: 'FF000000' } },
            };
          }
        }
      }

      // 5) xuất file
      const buf = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, record.so + '.xlsx');
  
      console.log('Export xong');
    } catch (err) {
      console.error('exportFromTemplate error:', err);
      alert(err.message || 'Lỗi khi xuất file');
    }
  }

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Số phiếu
                </TableCell>
                <TableCell>
                  Ngày nhập liệu
                </TableCell>
                <TableCell>
                  Chức năng
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((newdanhmucphieunhap, index) => (
                newdanhmucphieunhap ? <TableRow
                  hover
                  key={newdanhmucphieunhap.id}
                  selected={selectedNewdanhmucphieunhapIds.indexOf(newdanhmucphieunhap.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucphieunhap.so}
                    </Typography>
                  </TableCell>
                  
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucphieunhap.createdAt ? moment(newdanhmucphieunhap.createdAt).format('YYYY-MM-DD HH:mm:ss') : ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="export" onClick={() => exportExcelOne(newdanhmucphieunhap)}>
                      <Download style={{ color: "#3498db", width: '24px', height: '24px' }} />
                    </IconButton>
                    {(role.priority < 4) && <IconButton aria-label="edit" onClick={() => onSelected(newdanhmucphieunhap.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>}
                    {(role.priority < 4) && <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, newdanhmucphieunhap)}>
                      <Trash2Icon color='red' />
                    </IconButton>}
                  </TableCell>
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default NewdanhmucphieunhapLookupDetail;
